export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = async (path, options = {}) => {
  const res = await fetch(`${API}${path}`, { ...options, credentials: "include", headers: { "Content-Type": "application/json", ...(options.headers || {}) } });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).detail || "Terjadi kesalahan");
  return res.json();
};
export const download = async (path) => {
  const res = await fetch(`${API}${path}`, { credentials: "include" });
  if (!res.ok) {
    const { toast } = await import("sonner");
    toast.error((await res.json().catch(() => ({}))).detail || "Gagal mengunduh file");
    return;
  }
  const name = /filename="([^"]+)"/.exec(res.headers.get("Content-Disposition") || "")?.[1] || "unduhan";
  const url = URL.createObjectURL(await res.blob());
  const a = Object.assign(document.createElement("a"), { href: url, download: name });
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
